export default __webpack_public_path__ + "static/media/No_Results_Icon.e49da63a.svg";